import $ from 'jquery';

/**
 * Update dropdown options with new items.
 */
export function updateSelectOptions(
	$select: JQuery,
	items: Array<{ id: number; name: string }>,
	placeholder: string,
	preserveValue = true
): void {
	const currentValue = preserveValue ? $select.val() : null;
	const defaultLabel = $select.data('gpb-default-value');

	// Clear and rebuild options
	$select.empty();
	$select.append($('<option>', { value: '', text: placeholder }));

	items.forEach((item) => {
		$select.append(
			$('<option>', {
				value: item.id.toString(),
				text: item.name,
			})
		);
	});

	let valueToSet: string | null = null;

	// 1. Restore previous value if still valid
	if (
		currentValue &&
		items.some((item) => item.id.toString() === currentValue)
	) {
		valueToSet = currentValue as string;
	}

	// 2. Fallback to default label match (only if no value yet)
	if (!valueToSet && defaultLabel) {
		const match = items.find((item) => item.name === defaultLabel);

		if (match) {
			valueToSet = match.id.toString();
		}
	}

	// Apply value if found
	if (valueToSet) {
		$select.val(valueToSet);
	}

	$select.trigger('change');

	const el = $select.get(0);
	if (el) {
		el.dispatchEvent(new Event('change', { bubbles: true }));
	}
}

/**
 * Update radio button group with new items.
 */
export function updateRadioButtons(
	$radioContainer: JQuery,
	items: Array<{ id: number; name: string }>,
	formId: number,
	fieldId: number,
	preserveValue = true
): void {
	const currentValue = preserveValue
		? $radioContainer.find('input[type="radio"]:checked').val()
		: null;

	const defaultLabel = $radioContainer.data('gpb-default-value');

	let valueToSet: string | null = null;

	// 1. Restore previous value if still valid
	if (
		currentValue &&
		items.some((item) => item.id.toString() === currentValue)
	) {
		valueToSet = currentValue as string;
	}

	// 2. Fallback to default label match
	if (!valueToSet && defaultLabel) {
		const match = items.find((item) => item.name === defaultLabel);

		if (match) {
			valueToSet = match.id.toString();
		}
	}

	// Clear and rebuild radio buttons
	$radioContainer.empty();

	items.forEach((item, index) => {
		const inputId = `choice_${formId}_${fieldId}_${index}`;
		const isChecked = valueToSet && valueToSet === item.id.toString();

		const $li = $('<li>', { class: 'gchoice' });

		const $input = $('<input>', {
			type: 'radio',
			name: `input_${fieldId}`,
			id: inputId,
			value: item.id.toString(),
		});

		if (isChecked) {
			$input.prop('checked', true);
		}

		const $label = $('<label>', {
			for: inputId,
			text: item.name,
		});

		$li.append($input, $label);
		$radioContainer.append($li);
	});

	// Trigger change if a value was selected
	if (valueToSet) {
		const $checked = $radioContainer.find('input[type="radio"]:checked');
		$checked.trigger('change');

		const el = $radioContainer.get(0);
		if (el) {
			el.dispatchEvent(new Event('change', { bubbles: true }));
		}
	}
}
